import React from 'react';
import { useLocation } from 'react-router-dom';

export function useLocationFilters() {
    const { search } = useLocation();
    return React.useMemo(() => {
        return search
            .substr(1)
            .split('&')
            .filter((x) => x !== '')
            .map((x) => decodeURI(x))
            .map((x) => x.split('='));
    }, [search]);
}
